import Event from "./event";
import InfiniteScroll from "./infinite-scroll";
import Paging from "./paging";

export default {

    install(Vue) {
        Vue.use(Event);
        Vue.use(InfiniteScroll);
        Vue.use(Paging);
    },

}
